import { render } from "./AiChat.vue?vue&type=template&id=4fc3debe&scoped=true"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=4fc3debe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc3debe"]])

export default __exports__